// import CognitoAuth from "@/services/CognitoAuthService";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "readSerialNumber",
    component: () => import("../components/abrs/ReadSerialNumber.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/postVinNumber",
    name: "postVinNumber",
    component: () => import("../components/abrs/PostVinNumber.vue"),
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      if(from.name === "readSerialNumber" || from.name === "judgePattern"){
        next()
      } else {
        next({ path: "/" });
      }
    }  
  },
  {
    path: "/judgePattern",
    name: "judgePattern",
    component: () => import("../components/abrs/DisplayWorkPattern.vue"),
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      if(from.name === "readSerialNumber" || from.name === "postVinNumber"){
        next()
      } else {
        next({ path: "/" });
      }
    }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
